// src/lib/hrProjectFilter.js
// Zentraler Zugriff auf den HR-Projekt-/Survey-Filter.
// Key wird von mehreren HR-Seiten geteilt (HrOverview,
// HrDashboard, HrMentors, HrMentees, ConfirmedPairs).

const HR_PROJECT_FILTER_KEY = 'hr_overview_project_filter_v1';

// Liefert die gewaehlte survey_id als positive Ganzzahl
// oder null. Robust gegen JSON-Objekt-Werte, Leerstring,
// Muell. Wirft nie.
export function getHrProjectFilterId() {
  try {
    const raw = localStorage.getItem(HR_PROJECT_FILTER_KEY);
    if (!raw) return null;
    let candidate = raw;
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        candidate = parsed.surveyId ?? parsed.id ?? null;
      } else {
        candidate = parsed;
      }
    } catch {
      // raw war kein JSON, candidate bleibt der Rohstring
    }
    const n = Number(candidate);
    return Number.isInteger(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

// Schreibt die survey_id als schlichten String. Bei null,
// undefined oder leerem Wert wird der Key entfernt.
export function setHrProjectFilterId(id) {
  try {
    const n = Number(id);
    if (Number.isInteger(n) && n > 0) {
      localStorage.setItem(HR_PROJECT_FILTER_KEY, String(n));
    } else {
      localStorage.removeItem(HR_PROJECT_FILTER_KEY);
    }
  } catch {
    // localStorage nicht verfuegbar, still ignorieren
  }
}

export { HR_PROJECT_FILTER_KEY };
